import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'

const columns = [
  { title: 'Setting', prop: 'key' },
  { title: 'Value', prop: 'value', format: 'json' },
  { title: 'Updated', prop: 'updated_at', format: 'fromNow' }
]

const defaults = {
  order: [{ column: 'key', direction: 'desc' }],
  filters: {
    key_notin: ['services_menu', 'resources_menu', 'about_us_menu', 'genders', 'titles', 'post_nominal_letters', 'ethnicities', 'disciplines', 'discipline_classifications']
  }
}

const Settings = (props) => (
  <List
    title='Settings'
    apiPath='admin/settings'
    columns={columns}
    defaults={defaults}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
    buildMenuItems={menuItems}
    hideCreate
  />
)

export default Settings
